import { Heart, Users, Moon, BatteryLow, BookOpen, Wrench, Compass } from "lucide-react";
import { Reveal } from "./Reveal";

const differences = [
  [Heart, "Confidence before convenience"],
  [Users, "Parent involvement"],
  [Moon, "Odd Hour Lessons, 8PM–3AM"],
  [BatteryLow, "Fatigue awareness"],
  [BookOpen, "Real Life Workshops"],
  [Wrench, "Practical vehicle knowledge"],
  [Compass, "Experience before the experience happens"],
];

export default function Instructors() {
  return (
    <section id="instructors" className="px-6 md:px-12 py-24 md:py-32 max-w-[1600px] mx-auto">
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <div className="relative" data-testid="instructor-card-cameron-jackson">
            <div className="absolute -top-4 -right-4 w-full h-full border-2 border-[#F5B301]" />
            <div className="relative overflow-hidden aspect-video bg-[#111113]">
              <video
                src="/media/cameron.mp4"
                poster="/media/cameron-poster.jpg"
                controls
                preload="none"
                playsInline
                data-testid="cameron-video"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-5 left-8 bg-[#F5B301] text-[#0a0a0a] px-6 py-4 z-10">
              <p className="font-cabinet font-black text-xl leading-none uppercase">Cameron Jackson</p>
              <p className="text-xs uppercase tracking-widest mt-1 text-black/70">Instructor & Father of Four</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#F5B301] mb-6">03 — Your Instructor</p>
          <h2 className="font-script text-5xl md:text-7xl text-[#f5f5f0] -rotate-1">Hi, I'm Cameron.</h2>
          <p className="text-base md:text-lg text-white/60 leading-relaxed mt-8">
            I don't believe the driving test should be the finish line — I believe it's the starting line. My goal is simple: to help young drivers become safe, confident and considerate road users for life.
          </p>

          <h3 className="font-cabinet font-black uppercase tracking-tighter text-2xl text-[#F5B301] mt-12">
            What makes Real Life Learners different?
          </h3>
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-5 mt-8">
            {differences.map(([Icon, text]) => (
              <li key={text} className="flex items-center gap-4 text-sm font-semibold text-[#f5f5f0]">
                <span className="w-10 h-10 shrink-0 border border-[#F5B301] flex items-center justify-center">
                  <Icon className="w-4 h-4 text-[#F5B301]" />
                </span>
                {text}
              </li>
            ))}
          </ul>
          <p className="font-script text-3xl text-[#F5B301] mt-12 -rotate-1">I look forward to meeting you. — Cameron</p>
        </Reveal>
      </div>
    </section>
  );
}
